<template>
  <div class="fllowTmdAccountDialog">
    <div class="fllowTmdAccountDialogContent" :style="`background-image: url(${data.icon});`">
      
      <nd-button class="fllowAccount" @click="fllowTmdAccount" :class="`caseid-${caseid}`">一键复制去关注</nd-button>
    </div>
  </div> 
</template>

<script>
import { copyToClipbord } from '@/assets/utils'
export default {
  data () {
    return {
    }
  },
  props: {
    caseid: {
      type: [String, Number],
      default: ''
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    fllowTmdAccount () {
      copyToClipbord('ct_tmd')
      this.$message('公众号已复制，前往微信搜索关注吧')
    },
    show () {}
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.fllowTmdAccountDialog {
  @keyframes scale {
    to {transform: scale(1.1);}
  }
  .fllowTmdAccountDialogContent {
    width: 620px;
    height: 750px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    
    .fllowAccount {
        position: absolute;
        top: 540px;
        width: 440px;
        height: 80px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 50px;
    }
  }
}
</style>